import { PublicClientApplication, Configuration, AuthenticationResult } from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    clientId: 'a919164d-8b7c-43fb-8119-f1997d45ca4f', // Replace with your Azure AD App's Client ID
    authority: 'https://login.microsoftonline.com/258ac4e4-146a-411e-9dc8-79a9e12fd6da/v2.0', // Replace with your Tenant ID
    redirectUri: '/', // Replace with your app's redirect URI
  },
  cache: {
    cacheLocation: 'localStorage', // Cache location
    storeAuthStateInCookie: false, // Set to true for IE11 or Edge
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

// Initialize the MSAL instance
export const initializeMsalInstance = async () => {
  await msalInstance.initialize();
};

// Utility to acquire a valid access token
export const getAccessToken = async (
  scopes: string[] = ['a919164d-8b7c-43fb-8119-f1997d45ca4f/.default']
): Promise<string | null> => {
  try {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length === 0) {
      throw new Error('No accounts found. User may not be logged in.');
    }

    // Attempt to silently acquire a token
    const response: AuthenticationResult = await msalInstance.acquireTokenSilent({
      account: accounts[0],
      scopes,
    });

    return response.accessToken;
  } catch (error) {
    // console.error('Error acquiring token silently:', error);

    // Handle token refresh failure (e.g., redirect to login)
    if (error instanceof Error && error.message.includes('interaction_required')) {
      // Redirect to login if silent token acquisition fails
      await msalInstance.loginRedirect({ scopes });
    }

    return null;
  }
};
